import { EntityId } from '@reduxjs/toolkit';
import { CouponOutDTO } from 'app/main/design-system/models/coupon.type';
import { RewardType } from 'app/main/design-system/models/reward.type';
import { GameForm } from './ducks/games.slice';

export enum GameActions {
  GOOGLE = 'GOOGLE',
  OPENING = 'OPENING',
}

export enum GameType {
  WHEEL = 'WHEEL',
}

// RewardType est désormais partagé (games ↔ prono). Re-export pour compat des imports existants.
export { RewardType };

export interface StoreInfosOutDTO {
  action: GameActions;
  storeId: EntityId;
  link?: string;
  shortUrl: string;
}

export interface StoreInfosInDTO extends StoreInfosOutDTO {
  nbClicks: number;
  nbActions: number;
  nbPlayers: number;
}

export interface GameSettingsDTO {
  canLoose: boolean;
  onlyNewClients: boolean;
}

export interface GameRewardsDTO {
  id?: EntityId;
  localId: string;
  name: string;
  type: RewardType;
  points?: number;
  couponId?: EntityId;
  couponData?: CouponOutDTO;
  weight: number;
  quota?: number;
  disabledAt?: string;
  draw: number;
}

export interface GameOutDTO {
  name: string;
  pageHeader: string;
  franchiseId: EntityId;
  merchantId: EntityId;
  type: GameType;
  action: GameActions;
  storeInfos: StoreInfosOutDTO[];
  rewards: GameRewardsDTO[];
  startDate: string;
  endDate?: string;
  settings: GameSettingsDTO;
}

export interface GameInDTO extends GameOutDTO {
  id: string;
  dateCreated: string;
  lastModified: string;
  nbPlayers: number;
  disabledAt?: string;
}

export interface GameInfoDTO {
  id: EntityId;
  name: string;
  type: GameType;
  action: GameActions;
  franchiseId: EntityId;
  storeInfos: StoreInfosInDTO[];
  nbPlayers: number;
  nbActions: number;
  settings: GameSettingsDTO;
  startDate: string;
  endDate?: string;
  disabledAt?: string;
}

export interface GameListItemDTO {
  id: EntityId;
  action: GameActions;
  name: string;
  dateCreated: string;
  lastModified: string;
  nbActions: number;
  nbStores: number;
  nbPlayers: number;
  disabledAt?: string;
}

export const convertGameFormToGameDTO = (
  form: GameForm,
  rewards: GameRewardsDTO[],
  userId: string,
  franchiseId: string,
): GameOutDTO => {
  if (!form.name) {
    throw new Error('Game name is required');
  }
  if (!form.pageHeader) {
    throw new Error('Game header is required');
  }
  if (!form.action) {
    throw new Error('Game action is required');
  }
  if (!form.storeInfos || form.storeInfos.length === 0) {
    throw new Error('Store information is required');
  }
  if (!form.startDate) {
    throw new Error('Start date is required');
  }
  return {
    name: form.name,
    pageHeader: form.pageHeader,
    franchiseId,
    merchantId: userId,
    type: GameType.WHEEL,
    action: form.action,
    storeInfos: form.storeInfos,
    rewards,
    startDate: form.startDate,
    endDate: form.endDate,
    settings: {
      canLoose: (form.settings && form.settings.canLoose) ?? true,
      onlyNewClients: (form.settings && form.settings.onlyNewClients) ?? false,
    },
  };
};
